import { useAppContext } from '../AppContext';
import { Link } from 'react-router-dom';
import { FaFacebook, FaYoutube, FaTwitter, FaLinkedin, FaPhone, FaEnvelope, FaTelegram } from 'react-icons/fa';

import logo from '../assets/images/logo/netconn_engineering.png';
// import logo from '../assets/images/logo/company_logo.png';
// import logo from '../assets/images/logo/logo3d.png';

import './footer.css';

function Footer() {
  const { currentLanguage, currentPage } = useAppContext();

  const currentGregorianYear = new Date().getFullYear();
  let currentEthiopianYear = currentGregorianYear - 8;


  const currentDate = new Date().toLocaleString('en-US', { timeZone: 'Africa/Addis_Ababa' });
  const [month, day] = currentDate.split('/');

  const formattedCurrentYear = () => {

    if (currentLanguage === 'አማርኛ') {

      // Adjust for years after September 11
      if (parseInt(month) > 9 || (parseInt(month) === 9 && parseInt(day) > 11)) {
        currentEthiopianYear++;


      }
      return (
        <span className='current-year'>
          {currentEthiopianYear}
        </span>
      )
    }
    else {
      return (
        <span className='current-year'>
          {currentGregorianYear}
        </span>
      )

    }

  }

  const formattedCompanyName = (inHeader) => {

    // const companyName = currentLanguage === 'አማርኛ' ? 'ብሮስፌ' : 'netconn';
    const companyName = currentLanguage === 'አማርኛ' ? 'ኔትኮን ሶፍትዌር' : 'netconn Software';
    const nameLength = companyName.length;

    return (
      <span className='company-name'>
        {companyName.split(' ').map((word, wordIndex) => (
          inHeader ? (
            <span key={wordIndex}>
              {word.split('').map((char, charIndex) => (
                <span
                  key={charIndex}
                  style={
                    (wordIndex === 0) // Check if it's 'Puzzle' and apply color
                      ? { color: '#f5f5f5', textShadow: '0 4px 12px rgba(200, 200, 200, 0.5)' }
                      : { color: '#ffd230' } // Default color for 'Designs'
                  }
                >
                  {char}
                </span>
              ))}
              {wordIndex === 0 ? ' ' : ''} {/* Add space between words */}
            </span>
          ) :
            (
              <span key={wordIndex}>
                {word.split('').map((char, charIndex) => (
                  <span
                    key={charIndex}
                    style={
                      (wordIndex === 0 && charIndex !== char.length - 1) // Check if it's 'Puzzle' and apply color
                        ? { color: '#c0c0c0' }
                        : { color: '#f6f6f6' } // Default color for 'Designs'
                    }
                  >
                    {char}
                  </span>
                ))}
                {wordIndex === 0 ? ' ' : ''} {/* Add space between words */}
              </span>
            )
        )
        )
        }
      </span>
    );
  };

  const telegramAccount = process.env.REACT_APP_TELEGRAM_ACCOUNT;
  const xAccount = process.env.REACT_APP_X_ACCOUNT;
  const facebookAccount = process.env.REACT_APP_FACEBOOK_ACCOUNT;
  const youtubeAccount = process.env.REACT_APP_YOUTUBE_ACCOUNT;
  const phoneNumber = process.env.REACT_APP_PHONE_NUMBER;
  return (
    <div className='footer'>
      {currentLanguage === 'English' && (
        <div className='footer-container'>
          <div className='footer-navs'>
            <div className='column'>
              <h2 className='column-title'>Company</h2>
              <ul className='column-content'>

                <li>About</li>
                <li>Code of Conduct</li>
                <li>Refund & Cancellation policy</li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>Products</h2>
              <ul className='column-content'>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>Website Design</Link>
                </li>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>App Design</Link>
                </li>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>Software Solutions</Link>
                </li>

              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>Resources</h2>
              <ul className='column-content'>
                <li className='footer-link'>
                  <Link to="/blog"
                    style={{ color: '#000' }}>Blog</Link>
                </li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>Social</h2>
              <ul className='column-content'>

              <li>
                                        <a
                                            href={`https://t.me/${telegramAccount}`}
                                            target="_blank" rel="noopener noreferrer">
                                            <FaTelegram />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`https://www.facebook.com/${facebookAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaFacebook />
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a
                                            href={`https://www.youtube.com/${youtubeAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaYoutube />
                                        </a>
                                    </li> */}
                                    <li>
                                        <a
                                            href={`https://www.twitter.com/${xAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaTwitter />
                                        </a>
                                    </li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>Address</h2>
              <ul>
                <li>Bole Road Bahir Bldg 1st Floor office 1-7 | <br />in front of Getu Commercial</li>
                <li className='icon'>
                  <a href={`tel:${phoneNumber}`} target="_blank" rel="noopener noreferrer"><FaPhone /></a>

                </li>
                <li>+251-911-106380 | +251-911-781965 </li>
                {/* <li><FaEnvelope /> </li>
                                    <li>netconneng@gmail.com</li> */}
                <li className='icon'><a href="mailto:netconneng@gmail.com" target="_blank" rel="noopener noreferrer"><FaEnvelope /></a>netconneng@gmail.com</li>




              </ul>
            </div>
          </div>
          <div className='footer-motto'>
            <p><span className='company-name-footer'>{formattedCompanyName(true)}</span> <span style={{ color: '#4ddde0', letterSpacing: '3px' }}>| Tech Innovation Beyond Boundaries</span><br />Elevate Your Local Business in Ethiopia with Expert Software and Tech Solutions<br />
              | Website & App Design | Office Software Solutions | AI Consultancy | Branding |<br />
            </p>
            <img src={logo} className="logo-footer" alt="company logo for netconn" />
          </div>
          <div className='footer-motto' style={{ width: '100%', backgroundColor: '#050505' }} >
            <p style={{ width: '100%' }}>Powered by <span style={{ color: '#4ddde0', letterSpacing: '3px' }}>| netconn Engineering</span>
            </p>

          </div>
          <div className='footer-note'>
            {/* <p>Copyright &copy; 2023. All rights reserved.</p> */}
            <p>Copyright &copy; {formattedCurrentYear()}. All rights reserved.</p>

          </div>

        </div>


      )}
      {currentLanguage === 'አማርኛ' && (
        <div className='footer-container'>
          <div className='footer-navs'>
            <div className='column'>
              <h2 className='column-title'>ድርጅት</h2>
              <ul className='column-content'>

                <li>ስለ እኛ</li>
                <li>የስነምግባር ደንብ</li>
                <li>የተመላሽ ገንዘብ እና የስረዛ መመሪያ</li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>አግልግሎቶች</h2>
              <ul className='column-content'>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>ዌብሳይት ዲዛይን</Link>
                </li>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>መተግበሪያ ዲዛይን</Link>
                </li>
                <li className='footer-link'>
                  <Link to="/portfolio"
                    style={{ color: '#000' }}>ሶፍትዌር መፍትሄዎች</Link>
                </li>

              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>ይዘቶች</h2>
              <ul className='column-content'>
                <li className='footer-link'>
                  <Link to="/blog"
                    style={{ color: '#000' }}>ስነጽሁፍ</Link>
                </li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>ማህበራዊ ገጾች</h2>
              <ul className='column-content'>
              <li>
                                        <a
                                            href={`https://t.me/${telegramAccount}`}
                                            target="_blank" rel="noopener noreferrer">
                                            <FaTelegram />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`https://www.facebook.com/${facebookAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaFacebook />
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a
                                            href={`https://www.youtube.com/${youtubeAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaYoutube />
                                        </a>
                                    </li> */}
                                    <li>
                                        <a
                                            href={`https://www.twitter.com/${xAccount}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaTwitter />
                                        </a>
                                    </li>
              </ul>
            </div>
            <div className='column'>
              <h2 className='column-title'>አድራሻ</h2>
              <ul>
                <li>ቦሌ መንገድ ባህር ህንጻ 1ኛ ፎቅ ቢሮ 1-7 | <br />ጌቱ ኮሜርሻል ፊት ለፊት</li>
                <li className='icon'>
                  <a href={`tel:${phoneNumber}`} target="_blank" rel="noopener noreferrer"><FaPhone /></a>

                </li>
                <li>+251-911-106380 | +251-911-781965 </li>
               
                <li className='icon'><a href="mailto:netconneng@gmail.com" target="_blank" rel="noopener noreferrer"><FaEnvelope /></a>netconneng@gmail.com</li>




              </ul>
            </div>
          </div>
          <div className='footer-motto'>
            <p><span className='company-name-footer'>{formattedCompanyName(true)}</span> <span style={{ color: '#4ddde0', letterSpacing: '3px' }}>| የቴክኖሎጂ መፍትሄዎችን ያለ ወሠን</span><br />በኢትዩጵያ የሚገኝ አገልግሎትዎንና ንግድዎን በባለሙያ የሶፍትዌር እና የቴክ ሶሉሽን የተሠሩ መፍትሄዎች ይደግፉ<br />
              | ዌብሳይትና መተግበሪያ ዲዛይን | የቢሮ ሶፍትዌር መፍትሄዎች | AI ኮንሳልቲንግ | ብራንዲንግ |<br />
            </p>
            <img src={logo} className="logo-footer" alt="company logo for netconn" />
          </div>
          <div className='footer-motto' style={{ width: '100%', backgroundColor: '#050505' }} >
            <p style={{ width: '100%' }}>Powered by <span style={{ color: '#4ddde0', letterSpacing: '3px' }}>| netconn Engineering</span>
            </p>

          </div>
          <div className='footer-note'>
            <p>ኮፒ ራይት &copy; {formattedCurrentYear()} ዓ.ም. ፤ መብቱ በህግ የተጠበቀ ነው፡፡</p>

          </div>
          <div></div>
        </div>



      )}

    </div>

  );
}

export default Footer;
